import { type LiteClient, liteClient } from 'algoliasearch/lite'
import { useMemo } from 'react'

import { useAlgoliaConfigContext } from '../context/algoliaConfigContext'

import { useGetProxyClientOptions } from './useGetProxyClientOptions'

export const useProxySearchClient = (): LiteClient => {
  const { algoliaApiKey, algoliaApplicationId } = useAlgoliaConfigContext()
  const options = useGetProxyClientOptions()

  return useMemo(
    () => liteClient(algoliaApplicationId, algoliaApiKey, options),
    [algoliaApplicationId, algoliaApiKey, options],
  )
}
